import { render, staticRenderFns } from "./LoadingSpinner.vue?vue&type=template&id=d2b66ba0&"
import script from "./LoadingSpinner.ts?vue&type=script&lang=js&"
export * from "./LoadingSpinner.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports